import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Link } from '@sorare/routing';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LinkOverlay } from '@sorare/core/src/atoms/navigation/Box';
import { LabelL, LabelM, LabelS } from '@sorare/core/src/atoms/typography';
import { ANY_SPORT_MARKET_SECONDARY } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { LobbyTile } from 'components/home/LobbyTile';

import bigkeepScoutingBg from './assets/bigkeepScoutingBg.jpg';
import keepScoutingSquare from './assets/keepScoutingSquare.png';

const Wrapper = styled.div`
  opacity: 1;
  position: relative;

  transition: opacity 0.05s ease-in-out;

  &:hover {
    opacity: 0.5;
  }
`;

const StyledLobbyTile = styled(LobbyTile)`
  display: flex;
  height: 205px;
  align-items: end;

  background: url(${bigkeepScoutingBg}) no-repeat center center;
  background-size: cover;
`;

const CTA = styled(Button)`
  margin-left: auto;
`;

const CompactVariant = () => {
  const { generateSportContextPath } = useSportContext();

  return (
    <Wrapper>
      <LinkOverlay
        as={Link}
        to={generateSportContextPath(ANY_SPORT_MARKET_SECONDARY)}
      >
        <Horizontal>
          <img width={48} height={48} src={keepScoutingSquare} alt="" />
          <Vertical>
            <LabelM bold>
              <FormattedMessage
                id="ForYou.KeepScouting.title"
                defaultMessage="Keep Scouting"
              />
            </LabelM>
            <LabelM as="span" color="var(--c-nd-600)">
              <FormattedMessage
                id="ForYou.KeepScouting.subtitle"
                defaultMessage="Visit the market and get ready for 2025"
              />
            </LabelM>
          </Vertical>
          <CTA size="small" color="tertiary">
            <FormattedMessage
              id="ForYou.KeepScouting.CTA"
              defaultMessage="Visit Market"
            />
          </CTA>
        </Horizontal>
      </LinkOverlay>
    </Wrapper>
  );
};

const DefaultVariant = () => {
  const { generateSportContextPath } = useSportContext();

  return (
    <StyledLobbyTile
      outlineColor="#FF0974"
      label={
        <LabelS bold color="var(--c-white)">
          <FormattedMessage
            id="ForYou.KeepScouting.label"
            defaultMessage="Keep Scouting"
          />
        </LabelS>
      }
    >
      <LinkOverlay
        as={Link}
        to={generateSportContextPath(ANY_SPORT_MARKET_SECONDARY)}
      >
        <LabelL bold>
          <FormattedMessage
            id="ForYou.KeepScouting.subtitle"
            defaultMessage="Visit the market and get ready for 2025"
          />
        </LabelL>
      </LinkOverlay>
    </StyledLobbyTile>
  );
};

type Props = {
  compact?: boolean;
};

export const KeepScouting = ({ compact }: Props) => {
  if (compact) {
    return <CompactVariant />;
  }

  return <DefaultVariant />;
};
